import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

import {
    IHttpResponsesHandler,
    IHttpResponseHandlerSettings,
    HttpResponsesHandlersFactory,
} from "@bbwt/modules/data-service";

import { PagedCrudService } from "@features/grid";
import { PublishInfo } from "@main/reporting.v3/publishing/publish-info";
import { IPublishService } from "@main/reporting.v3/publishing/publish-service";

import { IOwnerUser, IWidgetSource, IWidgetSourcePreload } from "../core/reporting-models";


@Injectable()
export class WidgetSourceService extends PagedCrudService<IWidgetSource> implements IPublishService {
    readonly url: string = "api/reporting3/widget-source";
    readonly entityTitle: string = "Widget Source";


    constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
        super(http, handlersFactory);
    }


    getWidgetSourcePreload(widgetCode: string, settings?: IHttpResponseHandlerSettings): Promise<IWidgetSourcePreload> {
        const encodedCode: string = encodeURIComponent(widgetCode);
        const handler: IHttpResponsesHandler = this.handlersFactory.getDefault(settings);

        return this.httpGet<IWidgetSourcePreload>(`${encodedCode}/preload`, handler);
    }

    savePublishInfo(entityId: string, publishInfo: PublishInfo, settings?: IHttpResponseHandlerSettings): Promise<void> {
        const handler: IHttpResponsesHandler = this.handlersFactory.getForUpdate(this.entityTitle, settings);

        return this.httpPut<void>(`${entityId}/publish`, publishInfo, handler);
    }

    getUsersAllowedAsOwners(): Promise<IOwnerUser[]> {
        return this.handle(this.http.get<IOwnerUser[]>(`${this.url}/users-allowed-as-owners`));
    }

    changeOwner(widgetSourceId: string, ownerUserId: string): Promise<void> {
        return this.httpPut(`${widgetSourceId}/${ownerUserId}/change-owner`, null,
            this.handlersFactory.getForUpdate(this.entityTitle));
    }

    getPublishInfo(entityId: string, settings?: IHttpResponseHandlerSettings): Promise<PublishInfo> {
        const handler: IHttpResponsesHandler = this.handlersFactory.getForReadById(this.entityTitle, settings);

        return this.httpGet<PublishInfo>(`${entityId}/publish`, handler);
    }
}